export default {
  landingExperienceModelManager: () => import('@/pages/merchant/service/landingExperience/model.vue')
}
